document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.countdown-timer').forEach(initCountdown);
});

// Support Shopify theme editor live re-renders of the section
document.addEventListener('shopify:section:load', function (event) {
  var el = event.target.querySelector('.countdown-timer');
  if (el) initCountdown(el);
});

function initCountdown(el) {
  var targetString = el.getAttribute('data-target');
  if (!targetString) return;

  var target = new Date(targetString);
  if (isNaN(target.getTime())) return;

  var daysEl = el.querySelector('[data-days]');
  var hoursEl = el.querySelector('[data-hours]');
  var minutesEl = el.querySelector('[data-minutes]');
  var secondsEl = el.querySelector('[data-seconds]');
  var expiredPanel = el.parentElement.querySelector('[data-countdown-expired]');

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function tick() {
    var now = new Date();
    var diff = target.getTime() - now.getTime();

    if (diff <= 0) {
      el.hidden = true;
      if (expiredPanel) expiredPanel.hidden = false;
      clearInterval(intervalId);
      return;
    }

    var totalSeconds = Math.floor(diff / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);
  }

  tick();
  var intervalId = setInterval(tick, 1000);
}